const origin = window.location.origin;
const host = window.location.host;

// console.log('prod', window.location);

export const environment = {
  production: true,

  //@ts-ignore
  hammerApiUrl: origin + '/web/api',
  //@ts-ignore
  nostromoAuthApiUrl: origin + '/auth/api/v2',
  //@ts-ignore
  genesisApiUrl: origin + '/mycar/api/v2',
  //@ts-ignore
  logosApiUrl: origin + '/logos/api/v2',

  //@ts-ignore
  wsVehicleDataChangeServiceUrl: 'wss://' + host + '/web/ws_params',
  //@ts-ignore
  wsEventServiceUrl: 'wss://' + host + '/web/ws_notify',

  //@ts-ignore
  isChristmasEvent: window['env']?.['isChristmasEvent'] || false,

  hotjarId: 2926715
};
